/* ============================================================
   JB Travel World — email address obfuscation
   File: assets/jb-email.js
   Loaded once from layout/theme.liquid.

   Hides email addresses from harvesting bots: no mailto: links
   or addresses exist in the page HTML. Real links are assembled
   in the browser after the page loads.

   Usage anywhere in page or description HTML:
   <a href="#" class="js-obfuscated-email"
      data-user="help" data-domain="jbtravelworld.com">contact us</a>

   This replaces the identical inline <script> previously pasted
   into each page. Edit here, in one place.
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  var emailLinks = document.querySelectorAll('.js-obfuscated-email');

  emailLinks.forEach(function (link) {
    var user = link.getAttribute('data-user');
    var domain = link.getAttribute('data-domain');

    if (user && domain) {
      var email = user + '@' + domain;
      link.setAttribute('href', 'mailto:' + email);
      link.textContent = email;
      link.setAttribute('aria-label', 'Email ' + email);
    }
  });
});
